
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/better-chatgpt-ui",
      function () {
        return require("private-next-pages/better-chatgpt-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/better-chatgpt-ui"])
      });
    }
  